import VendorList from '../../slices/vendor/VendorList'
import VendorDetails from '../../slices/vendor/VendorDetails'
import VendorServiceList from '../../slices/vendor/VendorServiceList'

import VendorBookingList from '../../slices/vendor/VendorBookingList'
import VendorEmployeeList from '../../slices/vendor/VendorEmployeeList'
import VendorCustomerList from '../../slices/vendor/VendorCustomerList'

import VendorOfferList from '../../slices/vendor/VendorOffer'
import VendorOrders from '../../slices/vendor/VendorOrders'
import VendorTransactionList from '../../slices/vendor/VendorTransactionList'
import ServiceCategory from '../../slices/vendor/ServiceCategory'
import ServiceSubCategory from '../../slices/vendor/ServiceSubCategory'
import ProfileServices from '../../slices/vendor/ProfileServices'
import ProfileDetails from '../../slices/vendor/ProfileDetails'
import ProfileOfferList from '../../slices/vendor/ProfileOffer'

const vendorReducer = {
    vendorList: VendorList,
    vendorDetails: VendorDetails,
    vendorServiceList: VendorServiceList,
    vendorBookingList: VendorBookingList,
    vendorEmployeeList: VendorEmployeeList,
    vendorCustomerList: VendorCustomerList,
    vendorOfferList: VendorOfferList,
    vendorOrders:VendorOrders,
    vendorTransactionList:VendorTransactionList,
    serviceCategory:ServiceCategory,
    serviceSubCategory:ServiceSubCategory,
    profileServices:ProfileServices,
    profileDetails:ProfileDetails,
    profileOfferList:ProfileOfferList
};

export default vendorReducer;
